import { render, staticRenderFns } from "./FTBadge.vue?vue&type=template&id=962ed8ee&scoped=true&"
import script from "./FTBadge.vue?vue&type=script&lang=js&"
export * from "./FTBadge.vue?vue&type=script&lang=js&"
import style0 from "./FTBadge.vue?vue&type=style&index=0&id=962ed8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962ed8ee",
  null
  
)

export default component.exports